import { render } from "./AddCoupon.vue?vue&type=template&id=b3c4ee00&ts=true"
import script from "./AddCoupon.vue?vue&type=script&lang=ts"
export * from "./AddCoupon.vue?vue&type=script&lang=ts"

import "./AddCoupon.vue?vue&type=style&index=0&id=b3c4ee00&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__